import { type FormEvent, useState } from "react";

interface SubscriberSetupClaimScreenProps {
  userName: string;
  onClaim: (setupCode: string) => Promise<void>;
  onSignOut: () => void;
}

export function SubscriberSetupClaimScreen({
  userName,
  onClaim,
  onSignOut,
}: SubscriberSetupClaimScreenProps) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string>();

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const setupCode = String(data.get("setupCode") ?? "").trim();
    if (!setupCode) return;

    try {
      setBusy(true);
      setError(undefined);
      await onClaim(setupCode);
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : "اتصال سالن انجام نشد.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="app-shell" dir="rtl">
      <section className="section-card" style={{ margin: "auto", width: "min(92vw, 520px)" }}>
        <p className="section-kicker">راه‌اندازی مشترک</p>
        <h1>اتصال حساب به سالن</h1>
        <p className="section-note">
          {userName}، کدی را که مالک سامانه برای سالن شما صادر کرده وارد کنید. بعد از تأیید، شما
          مالک همان سالن می‌شوید و مدت اشتراک از امروز آغاز می‌شود.
        </p>

        <form className="operation-form" onSubmit={submit}>
          <label className="operation-field">
            کد راه‌اندازی
            <input
              name="setupCode"
              dir="ltr"
              autoComplete="one-time-code"
              placeholder="DS-XXXX-XXXX-XXXX-XXXX"
              required
            />
          </label>
          {error ? <p className="settings-warning">{error}</p> : null}
          <button type="submit" className="primary-button large-button" disabled={busy}>
            {busy ? "در حال اتصال…" : "اتصال حساب و ورود به سالن"}
          </button>
        </form>

        <button type="button" className="text-button" onClick={onSignOut}>
          خروج از حساب
        </button>
      </section>
    </main>
  );
}
